import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import authService from "@/services/modules/authService";
import NestedMenuItems from "@/components/appbar/DrawerNestedMenuItems";

export default {
  name: "navigation-drawer",
  components: { NestedMenuItems },
  props: ["menus"],

  data: () => ({
    goToPublicPage: process.env.VUE_APP_PUBLIC_BASE_URL,
    logoutLoading: false,
    show: false,
    mini: false,
    toggle: false,
    selected: [2],
    admins: [
      ["Management", "mdi-account-group"],
      ["Settings", "mdi-cog"]
    ],
    cruds: [
      ["Create", "mdi-shape-square-plus"],
      ["Read", "mdi-book-open-blank-variant"],
      ["Update", "mdi-update"],
      ["Delete", "mdi-delete"]
    ],
    visibleChildren: []
    // marketUrl: process.env.VUE_APP_MARKET_BASE_URL
  }),
  computed: {
    ...mapGetters({
      drawer: types.GET_DRAWER,
      userInfo: types.userInfo.getters.GET_USER_INFO
    }),
    drawerState: {
      get() {
        if (this.$vuetify.breakpoint.smAndDown) {
          return this.drawer;
        } else {
          return false;
        }
      },
      set(val) {
        this.drawerAction(val);
      }
    }
    // storeName() {
    //   this.$t("header.navigationDrawer").forEach(elem => {
    //     if (this.$route.path.includes(elem.to)) {
    //       this.drawerItemNameAction(elem.tooltip);
    //     }
    //   });
    // }
  },
  mounted() {},
  methods: {
    ...mapActions({
      drawerAction: types.ACTION_DRAWER,
      drawerItemNameAction: types.ACTION_DRAWER_ITEM_NAME
    }),
    signOutFunc() {
      authService
        .signOut({
          refresh_token: this.$cookies.get("refreshToken")
        })
        .then(() => {
          localStorage.removeItem("accessToken");
          localStorage.setItem("isAuth", "false");
          this.$cookies.remove(
            "accessToken",
            null,
            process.env.VUE_APP_COOKIES_DOMAIN
          );
          location.reload();
        });
    },
    // goToMarket() {
    //   window.location.replace(this.marketUrl);
    // },
    // goToInvestment() {
    //   window.location.replace("https://hello.excoino.com/");
    // },
    // goToDemoTrading() {
    //   window.location.replace("https://market.excoino.com/exchange/v-btc_v-usdt");
    // },

    // switchLangFunc() {
    //   // this.$router.push({
    //   //   query: Object.assign({}, this.$route.query, {
    //   //     lang: this.$i18n.locale,
    //   //   }),
    //   // });

    //   // localStorage.setItem("lang", `${this.$i18n.locale}`);

    //   if (this.$i18n.locale === "fa") {
    //     localStorage.setItem("lang", "en");
    //   } else {
    //     localStorage.setItem("lang", "fa");
    //   }
    //   this.$router.go();
    // },

    onChangeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("isDark", this.$vuetify.theme.dark);
    },

    toggleChildren(title) {
      const index = this.visibleChildren.indexOf(title);
      if (index === -1) {
        // If title is not in the array, add it
        this.visibleChildren.push(title);
      } else {
        // If title is already in the array, remove it
        this.visibleChildren.splice(index, 1);
      }
    },
    // isChildrenVisible(title) {
    //   return this.visibleChildren.includes(title); // Check if the title is present in the array
    // },
    navigate(link) {
      // Navigate using Vue Router if a link is provided
      if (link) {
        this.$router.push(link);
      }
    }
  }
};
